import { render, staticRenderFns } from "./FormItemTextSEO.vue?vue&type=template&id=24060fce&scoped=true&"
import script from "./FormItemTextSEO.vue?vue&type=script&lang=js&"
export * from "./FormItemTextSEO.vue?vue&type=script&lang=js&"
import style0 from "./FormItemTextSEO.vue?vue&type=style&index=0&id=24060fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24060fce",
  null
  
)

export default component.exports